export default __webpack_public_path__ + "static/media/chevron-down.62799361.svg";